import React from 'react';
import Button from './button';
import Square_Tick from '../../assets/icons/square-tick.svg';
import '../../assets/css/elements/service_item.css';
import yellowtape from '../../assets/icons/yellow_rectangle.svg'
import redtape from '../../assets/icons/red_ectangle.svg'
import { Arrow } from '../../assets/icons';

const ServiceItem = ({ 
    image, 
    title, 
    features, 
    serviceName, 
    buttonText = "Learn More",
    variant = "red",
}) => {
    const tape = variant === 'red' ? redtape : yellowtape;

    return (
        <div className="service-item">
            <div className="service-image-container">
                <img src={image} alt={title} className="service-image" />
                
                <div className="service-info">
                    {/* <h3 className="info-title">{title}</h3> */}
                    
                    <ul className="features-list">
                        {features.map((feature, index) => (
                            <li key={index} className="feature-item">
                                <img src={Square_Tick} alt="Square Tick" className="feature-icon" width='30px' />
                                {feature}
                            </li>
                        ))}
                    </ul>
                    
                    <Button 
                        text={buttonText}
                        variant={variant}
                        className="service-cta"
                        icon={<img src={Arrow} alt="arrow" className='arrow_up' />}
                    />
                    <img src={tape} alt="" className="tape service-tape" />
                </div>
            </div>
            
            <h2 className="service-name">{serviceName}</h2>
        </div>
    );
};

export default ServiceItem;